export const BorrowerConstants = {
    inspectionInteriorCardTabs: {
        Details: {
            name: "Details",
            icon: "list"
        },
        Documents: {
            name: "Documents",
            icon: "paperclip"
        },
        Inspections: {
            name: "Inspections",
            icon: "calendar check"
        }
    },
    currentInspectionInteriorCardTabs: {
      Details: {
          name: "Details",
          icon: "list"
      },
      Documents: {
          name: "Documents",
          icon: "paperclip"
      }
  },
    unUsedCurrentInspectionProperty: {
        allowEditId: "allowEditId", 
        loanDrawStatusNameId: "loanDrawStatusNameId", 
        nwccprojectId: "nwccprojectId", 
        workInspectionCompanyOrganizationId: "workInspectionCompanyOrganizationId"
    },
    unUsedPastInspectionProperty: {
        createdOn: "createdOn",
        loanDrawStatusNameId: "loanDrawStatusNameId",
        inspectionCompany: "inspectionCompany",
        inspectionStatus: "inspectionStatus",
        nwccprojectId: "nwccprojectId",
        updatedOn: "updatedOn",
        updatedBy: "updatedBy",
        workInspectionCompanyOrganizationId: "workInspectionCompanyOrganizationId"
    },
};